<script setup>
import { useI18n } from 'vue-i18n';

const props = defineProps({
  modelValue: { type: Object, default: () => ({}) },
});
const emit = defineEmits(['update:modelValue']);
const { t } = useI18n();
const fields = ['objective', 'required_information', 'handoff_when'];
const tones = ['warm', 'direct', 'consultative'];
const update = (field, value) =>
  emit('update:modelValue', { ...props.modelValue, [field]: value });
</script>

<template>
  <section class="space-y-3 rounded-xl border border-n-weak bg-n-solid-2 p-4">
    <h3 class="text-sm font-semibold text-n-slate-12">
      {{ t('AI_AGENTS.PLAYBOOK.TITLE') }}
    </h3>
    <p class="text-xs text-n-slate-11">
      {{ t('AI_AGENTS.PLAYBOOK.DESCRIPTION') }}
    </p>
    <label class="block space-y-1">
      <span class="text-xs font-medium text-n-slate-12">
        {{ t('AI_AGENTS.PLAYBOOK.TONE') }}
      </span>
      <select
        :value="modelValue.tone || 'warm'"
        class="w-full rounded-lg border border-n-weak bg-n-solid-1 px-3 py-2 text-sm text-n-slate-12"
        @change="update('tone', $event.target.value)"
      >
        <option v-for="tone in tones" :key="tone" :value="tone">
          {{ t(`AI_AGENTS.PLAYBOOK.TONES.${tone}`) }}
        </option>
      </select>
    </label>
    <label class="block space-y-1">
      <span class="text-xs font-medium text-n-slate-12">{{
        t('AI_AGENTS.PLAYBOOK.PRICE_POLICY')
      }}</span>
      <select
        :value="modelValue.price_policy || 'catalog'"
        class="w-full rounded-lg border border-n-weak bg-n-solid-1 px-3 py-2 text-sm text-n-slate-12"
        @change="update('price_policy', $event.target.value)"
      >
        <option value="catalog">
          {{ t('AI_AGENTS.PLAYBOOK.PRICE_CATALOG') }}
        </option>
        <option value="specialist_only">
          {{ t('AI_AGENTS.PLAYBOOK.PRICE_SPECIALIST') }}
        </option>
      </select>
    </label>
    <label v-for="field in fields" :key="field" class="block space-y-1">
      <span class="text-xs font-medium text-n-slate-12">
        {{ t(`AI_AGENTS.PLAYBOOK.${field.toUpperCase()}.LABEL`) }}
      </span>
      <textarea
        :value="modelValue[field] || ''"
        :placeholder="
          t(`AI_AGENTS.PLAYBOOK.${field.toUpperCase()}.PLACEHOLDER`)
        "
        rows="2"
        maxlength="2000"
        class="w-full rounded-lg border border-n-weak bg-n-solid-1 px-3 py-2 text-sm text-n-slate-12"
        @input="update(field, $event.target.value)"
      />
    </label>
    <p class="text-xs text-n-slate-11">
      {{ t('AI_AGENTS.PLAYBOOK.VERIFICATION_HINT') }}
    </p>
  </section>
</template>
